import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OWNERSHIP_OPTIONS = [
    { value: "all", label: "הכל" },
    { value: "mine", label: "שלי" },
    { value: "unassigned", label: "חסר כיסוי" },
];
function chipClass(active) {
    return `rounded-full border px-3 py-1 text-xs transition-colors ${active
        ? "border-indigo-400 bg-indigo-50 text-indigo-700 font-medium"
        : "border-slate-200 text-slate-600 hover:bg-slate-50"}`;
}
/** Secondary filter row shown on category tabs only. */
export function CategoryFilterBar({ ownership, hideDone, onOwnershipChange, onHideDoneChange, }) {
    return (_jsxs("div", { className: "flex flex-wrap items-center gap-1.5", dir: "rtl", children: [_jsx("div", { className: "flex items-center gap-1.5", children: OWNERSHIP_OPTIONS.map((opt) => (_jsx("button", { onClick: () => onOwnershipChange(opt.value), "aria-pressed": ownership === opt.value, className: chipClass(ownership === opt.value), children: opt.label }, opt.value))) }), _jsx("span", { className: "mx-0.5 h-4 w-px bg-slate-200", "aria-hidden": true }), _jsx("button", { onClick: () => onHideDoneChange(!hideDone), "aria-pressed": hideDone, className: chipClass(hideDone), children: "\u05DC\u05D0 \u05D1\u05D5\u05E6\u05E2\u05D5" })] }));
}
